export default function (value){
    return value.replace("'","''") // ' -> '' postgre -> '
}